"use strict";

exports.__esModule = true;
exports.removeSpecialChar = exports.pmt = exports.objVals = exports.numberFormat = exports.menuLinks = exports.jsUcfirst = exports.filterNumber = void 0;
var removeSpecialChar = function removeSpecialChar(val, symbol) {
  if (symbol === void 0) {
    symbol = "-";
  }
  if (typeof val === "undefined") {
    return val.replace(/[^\w\s]/gi, " ").replace(/\s\s+/g, " ").replace(/ /gi, symbol).toLowerCase();
  }
  return val;
};
exports.removeSpecialChar = removeSpecialChar;
var numberFormat = function numberFormat(num) {
  if (!num) return 0;
  return new Intl.NumberFormat("en-US", {}).format(num);
};
exports.numberFormat = numberFormat;
var filterNumber = function filterNumber(str) {
  if (!str) return 0;
  str = str.toString();
  return parseInt(str.replace(/[^\d.]/g, ""), 10);
};
exports.filterNumber = filterNumber;
var jsUcfirst = function jsUcfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.jsUcfirst = jsUcfirst;
var objVals = function objVals(obj) {
  return Object.values(obj);
};
exports.objVals = objVals;
var pmt = function pmt(rate, periods, present, future, type) {
  if (future === void 0) {
    future = 0;
  }
  if (type === void 0) {
    type = 1;
  }
  if (isNaN(rate) || isNaN(periods) || !periods || !rate) {
    return 0;
  }
  if (rate === 0) {
    return -((present + future) / periods);
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      return -((future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate));
    } else {
      return -(future * rate / (term - 1) + present * rate / (1 - 1 / term));
    }
  }
};
exports.pmt = pmt;
var menuLinks = function menuLinks(menu_data) {
  var menu_link = "";
  if (menu_data) {
    var _menu_data$strapi_par;
    if (menu_data != null && (_menu_data$strapi_par = menu_data.strapi_parent) != null && _menu_data$strapi_par.slug) {
      var _menu_data$strapi_par2;
      menu_link = "/" + (menu_data == null ? void 0 : (_menu_data$strapi_par2 = menu_data.strapi_parent) == null ? void 0 : _menu_data$strapi_par2.slug) + "/" + (menu_data == null ? void 0 : menu_data.slug) + "/";
    } else {
      menu_link = "/" + menu_data.slug + "/";
    }
  }
  return menu_link;
};
exports.menuLinks = menuLinks;